import { POST_PRESETS, type PostSettings } from "./post/post-model.ts";

/**
 * Qualidade gráfica em uso (Opções → Gráficos, F30): fatores lidos pelas camadas a cada quadro, sem
 * recriar nada. `distance` multiplica as distâncias de desenho (recursos, criaturas, itens no chão,
 * enfeites do chão) e do relevo (LOD); `grass` é a densidade do capim (0 a 1) e `details`, a dos
 * enfeites do chão (F44: segue a opção "Capim e detalhes"; 0 esconde). `blobs` é quantas sombras-blob
 * o shader desenha (F51: 16, ou 8 no preset Baixo; só o uniform da contagem muda). `animated` é quantas
 * criaturas usam o modelo animado ao mesmo tempo (F50: 12, ou 6 no Baixo); as outras ficam no boneco
 * procedural em lote. `post` é o pós-processamento (F52): o preset efetivo (no Automático, o medido),
 * as opções de Gráficos e "Reduzir lampejos"; o `PostFx` lê a cada quadro (o Automático escolhe sem
 * avisar ninguém). O padrão é o Médio, também nas vitrines (`&pos=` troca).
 */
export const QUALITY: { distance: number; grass: number; details: number; blobs: number; animated: number; shadows: boolean; post: PostSettings } = {
  distance: 1,
  grass: 1,
  details: 1,
  blobs: 16,
  animated: 12,
  // Sombra do sol (Fase 13): o tamanho do mapa vem do tier; desligada, só as sombras-blob.
  shadows: true,
  post: { tier: "medio", ...POST_PRESETS.medio, reduceFlashes: false },
};
